import React from "react";
import banner from "../../assets/01_Home/HYUNDAIKONA_17.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-pqr-component"
      style={{ backgroundImage: `url(${banner})` }}
    >
      <h1 className="mascara-banner-pqr-component">Contáctanos</h1>
    </div>
  );
};

export default BannerComponent;